import { cloneDeep } from 'lodash-es';

export interface PartnerSettings {
  logoUrl: string;
  colors?: CorporateColors;
  faviconUrl: string;
  partnershipId?: string;
  currencies?: string[];
  disableSignupLink?: boolean;
  customerFees?: {
    feeCurrency: string;
    itemFee: ItemFee;
  };
  termsAndConditionsSupplyParagraphs?: string;
  refundPolicy?: {
    allowed: boolean;
  };
  feeDisplay: FeeDisplay | null;
}

let settings: PartnerSettings;
let stashedSettings: PartnerSettings;

export const setPartnerSettings = (newSettings: PartnerSettings): void => {
  settings = newSettings;
};

export const getPartnerSettings = (): PartnerSettings => {
  return settings;
};

export const stashSettings = (): void => {
  stashedSettings = cloneDeep(settings);
};

export const restoreStashedSettings = (): void => {
  if (stashedSettings) {
    settings = cloneDeep(stashedSettings);
  }
};
